<script setup lang="ts">
const { user } = useUser()

const competitorPercentage = computed(() => {
	if (!user.value.current_team) {
		return 0
	}

	const competitorCount = user.value.current_team.competitor_url_count || 0

	return Math.round((competitorCount / user.value.current_team.plan.competitor_limit) * 100)
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<team-submenu />

		<div class="flex flex-col gap-3">
			<div>
				<h2 class="text-primary mb-4 rounded border-b py-2 text-2xl font-bold">
					{{ t('app.competitor_scrape_item_limit') }}
				</h2>
				<div class="max-w-xl text-center">
					<ui-progress v-model="competitorPercentage" />
					<span class="text-muted-foreground text-sm">{{ user.current_team?.competitor_url_count }} / {{ user.current_team?.plan.competitor_limit }}</span>
				</div>
			</div>

			<div>
				<h2 class="text-primary mb-4 rounded border-b py-2 text-2xl font-bold">
					{{ t('app.interval') }}
				</h2>
				<div class="max-w-xl text-sm">
					{{ t('app.data_interval_set_to') }}: <strong>{{ user.current_team?.scrape_interval }}</strong>
				</div>
			</div>
		</div>
	</content-wrapper>
</template>
